import styled from '@mui/system/styled';

export const TeamsTileInnerCnt = styled('div')({
  boxShadow: '0 6px 24px 0 rgb(0 0 0 / 5%), 0 0 0 1px rgb(0 0 0 / 8%)',
  borderRadius: 8,
  padding: 16,
  '& .gridItemFooter': {
    '& > span': {
      fontSize: 13,
      marginRight: 10,
      fontWeight: 400,
    },
  },
  '& .teamsTitleHeaderCnt': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 38,
  },
  '& .teamTitleCnt': {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    flexBasis: '100%',
    '& .teamsTitle': {
      fontSize: 16,
      marginLeft: 8,
      fontWeight: 600,
      width: '95%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
});
